import { Navigate, type RouteObject } from 'react-router-dom'
import { AppLayout } from '@/app/layouts/app-layout'
import { ProtectedRoute } from '@/app/routes/protected-route'
import { lazyWithReload } from '@/shared/lib/lazy-with-reload'

const PublicHomePage = lazyWithReload(() => import('@/features/landing/pages/public-home-page'), 'public-home-page')
const PublicModelsRuPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/public-models-page').then((module) => {
      const PublicModelsPage = module.default
      return {
        default: function PublicModelsRuPage() {
          return <PublicModelsPage locale="ru" />
        },
      }
    }),
  'public-models-ru-page',
)
const PublicModelsEnPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/public-models-page').then((module) => {
      const PublicModelsPage = module.default
      return {
        default: function PublicModelsEnPage() {
          return <PublicModelsPage locale="en" />
        },
      }
    }),
  'public-models-en-page',
)
const PublicModelProfileRuPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/public-model-profile-page').then((module) => {
      const PublicModelProfilePage = module.default
      return {
        default: function PublicModelProfileRuPage() {
          return <PublicModelProfilePage locale="ru" />
        },
      }
    }),
  'public-model-profile-ru-page',
)
const PublicModelProfileEnPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/public-model-profile-page').then((module) => {
      const PublicModelProfilePage = module.default
      return {
        default: function PublicModelProfileEnPage() {
          return <PublicModelProfilePage locale="en" />
        },
      }
    }),
  'public-model-profile-en-page',
)
const IiChatPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function IiChatPage() {
          return <IntentLandingPage intentKey="ii-chat" locale="ru" />
        },
      }
    }),
  'intent-ii-chat-page',
)
const IiDevushkaPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function IiDevushkaPage() {
          return <IntentLandingPage intentKey="ii-devushka" locale="ru" />
        },
      }
    }),
  'intent-ii-devushka-page',
)
const RoleplayChatRuPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function RoleplayChatRuPage() {
          return <IntentLandingPage intentKey="roleplay-chat" locale="ru" />
        },
      }
    }),
  'intent-roleplay-chat-ru-page',
)
const TelegramIiChatPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function TelegramIiChatPage() {
          return <IntentLandingPage intentKey="telegram-ii-chat" locale="ru" />
        },
      }
    }),
  'intent-telegram-ii-chat-page',
)
const AiChatPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function AiChatPage() {
          return <IntentLandingPage intentKey="ai-chat" locale="en" />
        },
      }
    }),
  'intent-ai-chat-page',
)
const AiGirlfriendPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function AiGirlfriendPage() {
          return <IntentLandingPage intentKey="ai-girlfriend" locale="en" />
        },
      }
    }),
  'intent-ai-girlfriend-page',
)
const RoleplayChatEnPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function RoleplayChatEnPage() {
          return <IntentLandingPage intentKey="roleplay-chat-en" locale="en" />
        },
      }
    }),
  'intent-roleplay-chat-en-page',
)
const TelegramAiCompanionPage = lazyWithReload(
  () =>
    import('@/features/seo/pages/intent-landing-page').then((module) => {
      const IntentLandingPage = module.default
      return {
        default: function TelegramAiCompanionPage() {
          return <IntentLandingPage intentKey="telegram-ai-companion" locale="en" />
        },
      }
    }),
  'intent-telegram-ai-companion-page',
)
const LoginPage = lazyWithReload(() => import('@/features/auth/pages/login-page'), 'login-page')
const ForgotPasswordPage = lazyWithReload(
  () => import('@/features/auth/pages/forgot-password-page'),
  'forgot-password-page',
)
const ResetPasswordPage = lazyWithReload(
  () => import('@/features/auth/pages/reset-password-page'),
  'reset-password-page',
)
const ChatPage = lazyWithReload(() => import('@/features/chat/pages/chat-page'), 'chat-page')
const ModelsPage = lazyWithReload(() => import('@/features/models/pages/models-page'), 'models-page')
const ModelProfilePage = lazyWithReload(
  () => import('@/features/models/pages/model-profile-page'),
  'model-profile-page',
)
const SettingsPage = lazyWithReload(
  () => import('@/features/settings/pages/settings-page'),
  'settings-page',
)
const NotFoundPage = lazyWithReload(
  () => import('@/features/misc/pages/not-found-page'),
  'not-found-page',
)

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <PublicHomePage />,
  },
  {
    path: '/en',
    element: <PublicHomePage />,
  },
  {
    path: '/models',
    element: <PublicModelsRuPage />,
  },
  {
    path: '/models/:modelSlug',
    element: <PublicModelProfileRuPage />,
  },
  {
    path: '/models/:modelSlug/roleplay',
    element: <PublicModelProfileRuPage />,
  },
  {
    path: '/en/models',
    element: <PublicModelsEnPage />,
  },
  {
    path: '/en/models/:modelSlug',
    element: <PublicModelProfileEnPage />,
  },
  {
    path: '/en/models/:modelSlug/roleplay',
    element: <PublicModelProfileEnPage />,
  },
  {
    path: '/ii-chat',
    element: <IiChatPage />,
  },
  {
    path: '/ii-devushka',
    element: <IiDevushkaPage />,
  },
  {
    path: '/roleplay-chat',
    element: <RoleplayChatRuPage />,
  },
  {
    path: '/telegram-ii-chat',
    element: <TelegramIiChatPage />,
  },
  {
    path: '/en/ai-chat',
    element: <AiChatPage />,
  },
  {
    path: '/en/ai-girlfriend',
    element: <AiGirlfriendPage />,
  },
  {
    path: '/en/roleplay-chat',
    element: <RoleplayChatEnPage />,
  },
  {
    path: '/en/telegram-ai-companion',
    element: <TelegramAiCompanionPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/app',
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="chat" replace />,
          },
          {
            path: 'chat',
            element: <ChatPage />,
          },
          {
            path: 'chat/:chatId',
            element: <ChatPage />,
          },
          {
            path: 'models',
            element: <ModelsPage />,
          },
          {
            path: 'models/:modelId',
            element: <ModelProfilePage />,
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]
